import { Link, Outlet } from 'react-router-dom';
import { Footer } from './Footer';
import { useAuth } from '../../hooks/useAuth';

function scrollTo(id: string) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
  else window.scrollTo({ top: 0, behavior: 'smooth' });
}

export function PublicLayout() {
  const { user } = useAuth();
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0A0416' }}>
      <header style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, backgroundColor: 'rgba(11,10,8,0.82)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', borderBottom: '1px solid rgba(212,175,55,0.15)' }}>
        <nav aria-label="Navegação principal" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link to="/" aria-label="Professya, página inicial" style={{ fontFamily: 'var(--font-display)', fontSize: '1.2rem', fontWeight: 400, fontStyle: 'italic', color: 'rgba(255,255,255,0.92)', letterSpacing: '0.04em', textDecoration: 'none' }}>
            Professya <span style={{ color: '#D4AF37', fontStyle: 'normal', fontSize: '0.8em' }}>✦</span>
          </Link>
          <div style={{ display: 'flex', alignItems: 'center', gap: '2rem' }}>
            <button onClick={() => scrollTo('sistemas')} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, color: 'rgba(255,255,255,0.82)', fontSize: 'var(--text-label)', fontFamily: 'var(--font-body)' }}>Sistemas</button>
            <a href="/#ritual" style={{ textDecoration: 'none', color: 'rgba(255,255,255,0.82)', fontSize: 'var(--text-label)', fontFamily: 'var(--font-body)' }}>Como funciona</a>
            <Link to="/pricing" style={{ textDecoration: 'none', color: 'rgba(255,255,255,0.82)', fontSize: 'var(--text-label)', fontFamily: 'var(--font-body)' }}>Assinatura</Link>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            {user ? (
              <Link to="/dashboard" className="btn btn-primary" style={{ padding: '0 1.25rem', minHeight: '38px' }}>Minha conta</Link>
            ) : (
              <>
                <Link to="/login" className="nav-desktop" style={{ textDecoration: 'none', color: 'rgba(255,255,255,0.82)', fontSize: 'var(--text-label)', fontFamily: 'var(--font-body)' }}>Entrar</Link>
                <Link to="/register" style={{ textDecoration: 'none', border: '1px solid rgba(212,175,55,0.6)', borderRadius: '6px', padding: '0.35rem 1.1rem', color: '#D4AF37', fontSize: 'var(--text-label)', fontFamily: 'var(--font-body)' }}>Começar</Link>
              </>
            )}
          </div>
        </nav>
      </header>
      <main style={{ paddingTop: '60px' }}><Outlet /></main>
      <Footer />
    </div>
  );
}
